/* eslint-disable max-lines-per-function */
import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import dayjs from 'dayjs'
import ViewMore from '../components/ViewMore'

type PeriodRangeState = {
  readonly period?: string | null
  readonly startDate?: string | null
  readonly endDate?: string | null
}

const getDefaultPeriodRange = (): PeriodRangeState => {
  const end = dayjs()
  const start = dayjs().subtract(7, 'day')
  return {
    period: '1',
    startDate: start.toISOString(),
    endDate: end.toISOString(),
  }
}

export default function Index() {
  const { translate } = useLang()
  const forceRefresh = useHookstate(false)
  const name = useHookstate<string | null>(null)
  const agencyId = useHookstate<number | null>(null)
  const deviceTypeId = useHookstate<number | null>(null)
  const surveyItemId = useHookstate<number | null>(null)
  const deviceId = useHookstate<number | null>(null)
  const dispatchGroupId = useHookstate<number | null>(null)
  const userId = useHookstate<number | null>(null)
  const searchTask = useHookstate<string | null>(null)
  const isOperational = useHookstate<boolean | null>(null)
  const periodRange = useHookstate<PeriodRangeState>(getDefaultPeriodRange())

  useEffect(() => {
    document.title = translate('Resources - Dispatch System')
  }, [])


  const surveyFilter = [
    {
      name: 'device_id',
      type: 'device_id',
      placeholder: 'Dispositivo',
      variable: deviceId,
    },
    {
      type: 'searchTask',
      placeholder: 'Enter a task',
      variable: searchTask,
    },
    {
      name: 'dispatch_group_id',
      type: 'dispatch_group_id',
      placeholder: 'Grupo de Despacho',
      variable: dispatchGroupId,
    },
    {
      name: 'user_id',
      type: 'user_id',
      placeholder: 'Usuário',
      variable: userId,
    },
    {
      name: 'start_date',
      type: 'hidden',
      variable: periodRange.nested('startDate'),
    },
    {
      name: 'finish_date',
      type: 'hidden',
      variable: periodRange.nested('endDate'),
    },
    // {
    //   name: 'item_status',
    //   type: 'item_status',
    //   placeholder: 'Situação',
    //   variable: isOperational,
    // },
    {
      name: 'is_operational',
      type: 'boolean',
      placeholder: translate('Approved'),
      variable: isOperational,
    },
    {
      // sem "name" para não enviar esse campo na query
      type: 'period',
      placeholder: 'Período',
      variable: periodRange,
      gridSize: 6,
      sendToRequest: false,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="inspection"
        title={translate('Inspection')}
        disableColumnsFilters
        viewTitle={translate('Inspection')}
        canView={true}
        showCreateButton={false}
        customViewMoreComponent={ViewMore}
        showInViewMore={[
          'device:name',
          'is_operational',
          'agency:name',
          'dispatch_group:name',
          'inspection_item_records:inspection_item:name',
          'inspection_item_records:notes',
          'created_at',
        ]}
        datesField={['created_at']}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={surveyFilter}
        clearFilters={() => {
          name.set('')
          agencyId.set(null)
          deviceTypeId.set(null)
          surveyItemId.set(null)
          deviceId.set(null)
          dispatchGroupId.set(null)
          userId.set(null)
          isOperational.set(null)
          periodRange.set(getDefaultPeriodRange())
          forceRefresh.set(!forceRefresh.get())
        }}
        notSortable={[
          // se quiser evitar ordenação pelas colunas com arrays
          'inspection_item_records',
        ]}
        forceOrderColumns={[
          'device:name',
          'is_operational',
          'agency:name',
          'dispatch_group:name',
          'created_at',
        ]}
        aliasLabel={[
          { column: 'is_operational', label: translate('Approved') },
          { column: 'device:name', label: translate('Device:name') },
          { column: 'agency:name', label: translate('Agency:name') },
          { column: 'dispatch_group:name', label: translate('Dispatch Group') },
        ]}
        exceptColumns={['deleted_at', 'updated_at']}
        cellLabel={[
          {
            field: 'required',
            value: { 0: 'Não', 1: 'Sim' },
          },
          {
            // 'Atuação' mapeada a partir de is_operational
            field: 'is_operational',
            value: { 0: 'Não ', 1: 'Sim' },
          },
          {
            // exemplo: mapear status dos itens (se precisar)
            field: 'inspection_item_records:item_status',
            value: { 1: 'OK', 2: 'Não', 3: 'Indefinido', 4: 'Com problema' },
          },
        ]}
      />
    </Layout>
  )
}
